import RelationshipMetadata from "../../RelationshipMetadata";

class UserGroupUserGroupAccountUserRelationshipMetadata extends RelationshipMetadata {
    constructor() {
        super();

        this.name = "UserGroupUserGroupAccountUserRelationshipMetadata";
        this.parentEnterpriseComponent = "UserGroup";
        this.childEnterpriseComponent = "UserGroupAccountUser";
        this.sourceAttribute = "USID";
        this.destinationAttribute = "UserGroupUSID";
    }
}

export default UserGroupUserGroupAccountUserRelationshipMetadata;